"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Search = exports.SearchInput = exports.fadeIn = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const shared_1 = require("../../shared");
const atoms_1 = require("../atoms");
const inputWidth = 240;
exports.fadeIn = (0, styled_components_1.keyframes) `
    0% {
        width: 0;
        opacity: 0;
    }
    100% {
        width: ${inputWidth}px;
        opacity: 1;
    }
`;
exports.SearchInput = styled_components_1.default.input `
	&&&.search-input {
		font-family: ${(p) => p.theme.fonts.default};
		background: transparent;
		font-size: 16px;
		color: ${(p) => p.theme.palette.text.primary};
		letter-spacing: normal;
		line-height: normal;
		word-spacing: normal;
		text-transform: none;
		text-indent: 0px;
		text-shadow: none;
		border: none;
		appearance: none;
		height: 100%;
		width: ${inputWidth}px;
		outline: none;
		padding: 5px 10px;
		&:focus {
			outline: none;
			box-shadow: none;
		}
	}
`;
const Styled = styled_components_1.default.div `
	padding: 5px 0;
	.extension {
		&.hidden {
			display: none;
		}
		background: ${(p) => p.theme.palette.background.paper};
		border-radius: 3px;
		height: 100%;
		display: flex;
		align-items: center;
		justify-items: stretch;

		${exports.SearchInput} {
			animation: ${exports.fadeIn} 0.4s ${(p) => p.theme.easing};
			transition: width 0.4s cubic-bezier(0.075, 0.82, 1, 1), opacity 0.4s cubic-bezier(0.075, 0.82, 1, 1);
		}
	}

	&& {
		.search-icon {
			padding: 12px 14px;
		}

		.close-icon {
			position: static;
			padding: 12px 10px;
			&:after {
				content: "";
				display: none;
			}
		}
	}
`;
const Search = ({ onSearch }) => {
    const { messages } = (0, shared_1.useMessages)();
    const inputEl = (0, react_1.useRef)(null);
    const { searchOpen, setSearchOpen } = (0, shared_1.useSearchOpen)();
    const [searchText, setSearchText] = (0, react_1.useState)("");
    const { setMobileMenuOpen } = (0, shared_1.useMobileMenu)();
    const closeMenus = (0, shared_1.useCloseAllMenus)();
    const openAndFocus = (0, react_1.useCallback)(() => {
        setMobileMenuOpen(false);
        setSearchOpen(true);
        //setTimeout required to render the input and then focus it
        setTimeout(() => {
            if (inputEl && inputEl.current) {
                inputEl.current.focus({ preventScroll: true });
            }
        }, 10);
    }, [inputEl === null || inputEl === void 0 ? void 0 : inputEl.current, setMobileMenuOpen, setSearchOpen]);
    const onBlur = (0, react_1.useCallback)(() => {
        setSearchOpen(false);
    }, [setSearchOpen]);
    const onChange = (0, react_1.useCallback)((e) => {
        setSearchText(e.currentTarget.value);
    }, [setSearchText]);
    const executeSearch = (0, react_1.useCallback)((e) => {
        if (onSearch && typeof onSearch === "function") {
            onSearch(searchText);
            setSearchText("");
            if (e && e.target) {
                e.target.blur();
            }
            closeMenus();
        }
    }, [onSearch, searchText, closeMenus]);
    const onKeyDown = (0, react_1.useCallback)((e) => {
        if (e && e.key === "Enter") {
            executeSearch(e);
        }
        else if (e && e.key === "Escape") {
            setSearchOpen(false);
        }
    }, [executeSearch, setSearchOpen]);
    const onKeyDownIcon = (0, react_1.useCallback)((e) => {
        if (e && e.key === "Enter") {
            openAndFocus();
        }
    }, [openAndFocus]);
    return (react_1.default.createElement(Styled, null,
        react_1.default.createElement("div", { className: `extension ${!searchOpen ? "hidden" : ""}` },
            react_1.default.createElement(exports.SearchInput, { className: "search-input", autoComplete: "off", ref: inputEl, tabIndex: -1, type: "text", name: "keyword", id: "query", "aria-label": messages.search, placeholder: messages.search_bar, onChange: onChange, onKeyDown: onKeyDown, onSubmit: executeSearch, value: searchText, onBlur: onBlur }),
            react_1.default.createElement(atoms_1.CloseIcon, { onClick: onBlur })),
        !searchOpen ? react_1.default.createElement(atoms_1.SearchIcon, { onClick: openAndFocus, onKeyDown: onKeyDownIcon }) : ""));
};
exports.Search = Search;
//# sourceMappingURL=Search.js.map